var React = require('react');

function IconArrowUp (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#9e9e9e","d":"M4 16l2.115 2.115 8.385-8.37V28h3V9.745l8.37 8.385L28 16 16 4z","transform":"translate(-4 -4)"}));
}

IconArrowUp.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconArrowUp;

IconArrowUp.default = IconArrowUp;
